<main class="container">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
        <div class="row">
            @if (!isCompleted){
            <div class="col col-12">
                <form class="branded">
                    <h1>request app permissions</h1>
                    <mat-error></mat-error>

                    @if(allowClientAppTypeSelection)
                    {
                    <fieldset class="pb-4">

                        <generic-button-toggles [disabled]="appSearchInProgress || clientApp !== undefined"
                            [options]="options" [title]="title" [initialSelection]="initialSelection"
                            (selectionChange)="handleToggleChange($event)">
                        </generic-button-toggles>

                        <div class="support-toggle-description">
                            @switch (clientAppType) {
                            @case (appReg){
                            the permissions requested will be granted to the <span class="font-weight-bold"> service
                                principal</span> associated with the <span class="font-weight-bold">
                                {{appReg}}</span>
                            }
                            @case (managedIdentity){
                            the permissions requested will be granted to the <span class="font-weight-bold">
                                {{managedIdentity | formatText}}</span>
                            }
                            }
                        </div>

                    </fieldset>
                    }

                    <fieldset class="pb-3">
                        <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white">
                            <p><strong>client application</strong></p>
                        </legend>
                        @if (clientApp === undefined){
                        <app-search [servicePrincipals]="clientAppType !== appReg"
                            [servicePrincipalsMustBeManagedIdentity]="clientAppType === managedIdentity"
                            (searchFoundNoExposedPermissions)="noExposedPermissionsFound($event)" [ownedApps]="true"
                            [searchPermissions]="false" [showTitle]="true" (appSelected)="clientAppSelected($event)"
                            (searchInProgress)="searchStatusChanged($event)" />
                        } @else if (displayClientApp !== undefined){
                        <display-form [displayObject]="displayClientApp" [includeRefreshButton]="true"
                            (refreshClicked)="resetClientAppSelected()" />
                        @if(showUpdateApplication)
                        {
                        <update-application-form [onlyApplicationsToUpdate]="[clientApp]"
                            (updatedApplications)="updatedApplications($event)"></update-application-form>
                        }
                        }
                    </fieldset>

                    @if(!showUpdateApplication)
                    {
                    <fieldset class="pb-3">
                        <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white">
                            <p><strong>resource application</strong></p>
                        </legend>
                        @if (resourceApp === undefined){
                        <app-search [sortable]="true" [includeNumberOfExposedPermissions]="true" [ownedApps]="false"
                            [searchPermissions]="true" [servicePrincipals]="true"
                            (appSelected)="resourceAppSelected($event)"
                            (searchFoundNoExposedPermissions)="noExposedPermissionsFound($event)"
                            [onlyShowApplicationPermissions]="clientAppType === managedIdentity" />
                        }@else if (displayResourceApp !== undefined){
                        <display-form [displayObject]="displayResourceApp" [includeRefreshButton]="true"
                            (refreshClicked)="resetResourceAppSelected()" />
                        }
                    </fieldset>

                    @if (searchFoundNoExposedPermissions){
                    <div class="row pb-4">
                        <div class="col-12">
                            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        can't find a non-chevron application permission
                                    </mat-panel-title>
                                    <mat-panel-description>
                                        expand to see which ones are requestable from IdAMP
                                    </mat-panel-description>
                                </mat-expansion-panel-header>
                                <app-requestable-permissions></app-requestable-permissions>
                            </mat-expansion-panel>
                        </div>
                    </div>
                    }
                    <mat-divider></mat-divider>
                    <fieldset class="pb-3">
                        <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white">
                            <p><strong>justification</strong></p>
                        </legend>
                        <div class="row">
                            <div class="col-12">
                                <mat-form-field appearance="outline" class="w-100"
                                    matTooltip="Justification for permissions request" subscriptSizing="dynamic">
                                    <mat-label>justification</mat-label>
                                    <input matInput [formControl]="justification">
                                    <mat-error>Justification is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </fieldset>

                    <mat-divider></mat-divider>

                    <!-- ── LP Evaluate button (Graph only) ──────────────────── -->
                    @if (resourceApp !== undefined && isGraphResourceApp) {
                    <fieldset class="pb-2 pt-2">
                        <div class="lp-evaluate-bar">
                            <span class="lp-evaluate-hint">
                                @if ((justification.value?.trim()?.length ?? 0) < LP_EVAL_MIN_CHARS) {
                                    add at least {{LP_EVAL_MIN_CHARS}} characters to your justification to enable AI review
                                } @else {
                                    AI least-privilege review available
                                }
                                <mat-icon class="lp-ai-info-icon" aria-label="AI disclaimer"
                                    matTooltip="Pilot feature &mdash; AI suggestions may be inaccurate or incomplete. Always verify recommendations before submitting. Do not include sensitive information in your justification."
                                    matTooltipPosition="above"
                                    matTooltipClass="lp-ai-tooltip">
                                    info_outline
                                </mat-icon>
                            </span>
                            <button class="button lp-evaluate-btn" type="button"
                                    [disabled]="!canEvaluate"
                                    (click)="evaluatePermissions()">
                                @if (lpState.status === 'evaluating') {
                                    <mat-spinner [diameter]="16" class="lp-inline-spinner"></mat-spinner>
                                    evaluating&hellip;
                                } @else {
                                    evaluate with AI
                                }
                            </button>
                        </div>
                    </fieldset>
                    }

                    <!-- ── LP Evaluation result panel ────────────────────────── -->
                    @if (lpState.status !== 'idle') {
                    <fieldset class="pb-3 lp-result-panel">
                        <legend class="form-row p-2 pl-3 mb-0" [ngClass]="lpLegendClass">
                            <p class="mb-0 d-flex align-items-center">
                                <strong>AI least-privilege review</strong>
                                @if (lpState.status !== 'evaluating' && lpBadgeLabel) {
                                    <span class="lp-badge ms-2">{{ lpBadgeLabel }}</span>
                                }
                                @if (lpState.status === 'evaluating') {
                                    <mat-spinner [diameter]="14" class="lp-inline-spinner ms-2"></mat-spinner>
                                }
                            </p>
                        </legend>

                        <div class="lp-result-body">

                            <!-- UX moment 2: Tier 0 warning banner (independent of AI decision) -->
                            @if (lpState.result?.tier0Permissions?.length) {
                            <div class="lp-tier0-result-banner">
                                <div class="lp-tier0-banner-header">
                                    <mat-icon class="lp-tier0-icon">warning</mat-icon>
                                    <strong>Tier 0 high-privilege permission warning</strong>
                                </div>
                                <p class="lp-tier0-warning-text">{{ lpState.result!.tier0Warning }}</p>
                                <p class="lp-tier0-perm-list">
                                    Flagged permissions:
                                    @for (name of lpState.result!.tier0Permissions!; track name) {
                                        <span class="lp-tier0-perm-badge">{{ name }}</span>
                                    }
                                </p>
                                <p class="lp-tier0-clarification-note">Note: this is an approval-difficulty warning. The AI may still agree with your request if your justification is strong.</p>
                                <p class="lp-tier0-ticket-prompt">
                                    To proceed, please
                                    <a href="https://go.chevron.com/diservices" target="_blank" rel="noopener noreferrer" class="lp-tier0-ticket-link">open a ticket with the Identity team</a>.
                                    When submitting, set <span class="lp-tier0-ticket-field">Product/Service</span> to
                                    <span class="lp-tier0-ticket-value">PKI (Certificate management/Blob recovery request)</span>.
                                </p>
                            </div>
                            }

                            <!-- loading state -->
                            @if (lpState.status === 'evaluating') {
                            <p class="lp-loading-msg">Searching permission catalog and analysing justification&hellip;</p>
                            }

                            <!-- content safety block -->
                            @else if (lpState.status === 'blocked') {
                            <p class="lp-explanation lp-text-danger">
                                Your justification was flagged by content safety filters.
                                Please revise it to use clear, technical language and try again.
                            </p>
                            }

                            <!-- service error -->
                            @else if (lpState.status === 'error') {
                            <p class="lp-explanation lp-text-danger">
                                Unable to complete AI review: {{ lpState.errorMessage }}
                            </p>
                            }

                            <!-- Agree -->
                            @else if (lpState.result?.decisionType === 'Agree') {
                            <p class="lp-section-title">Permissions align with the stated justification:</p>
                            @for (p of lpState.result!.recommendedPermissions; track p.name) {
                            <div class="lp-permission-row lp-row-agree">
                                <span class="lp-perm-name">{{ p.name }}</span>
                                <span class="lp-perm-type">{{ p.isDelegated ? 'delegated' : 'application' }}</span>
                                <span class="lp-perm-reason">{{ p.reason }}</span>
                            </div>
                            }
                            <p class="lp-explanation">{{ lpState.result!.explanation }}</p>
                            }

                            <!-- RecommendDifferent -->
                            @else if (lpState.result?.decisionType === 'RecommendDifferent') {
                            @if (lpState.result!.recommendedPermissions.length > 0) {
                            <p class="lp-section-title">Suggested least-privilege permissions:</p>
                            @for (p of lpState.result!.recommendedPermissions; track p.name) {
                            <div class="lp-permission-row lp-row-suggest">
                                <span class="lp-perm-name">{{ p.name }}</span>
                                <span class="lp-perm-type">{{ p.isDelegated ? 'delegated' : 'application' }}</span>
                                <span class="lp-perm-reason">{{ p.reason }}</span>
                            </div>
                            }
                            }
                            @if (lpState.result!.excludedPermissions.length > 0) {
                            <p class="lp-section-title lp-section-title-exclude">Permissions to remove:</p>
                            @for (p of lpState.result!.excludedPermissions; track p.name) {
                            <div class="lp-permission-row lp-row-exclude">
                                <span class="lp-perm-name">{{ p.name }}</span>
                                <span class="lp-perm-type">{{ p.isDelegated ? 'delegated' : 'application' }}</span>
                                <span class="lp-perm-reason">{{ p.reason }}</span>
                            </div>
                            }
                            }
                            <p class="lp-explanation">{{ lpState.result!.explanation }}</p>
                            <div class="lp-override-bar">
                                <span class="lp-override-hint">You can adjust your selection above, or submit your original request as-is — the reviewer will see this recommendation.</span>
                            </div>
                            }

                            <!-- Clarify -->
                            @else if (lpState.result?.decisionType === 'Clarify') {
                            <p class="lp-section-title">The following clarifications are needed before this request can proceed:</p>
                            <ul class="lp-questions">
                                @for (q of lpState.result!.clarificationQuestions; track q) {
                                <li>{{ q }}</li>
                                }
                            </ul>
                            <p class="lp-explanation">{{ lpState.result!.explanation }}</p>
                            <div class="lp-override-bar">
                                <span class="lp-override-hint">You can update your justification and re-evaluate, or submit as-is — the reviewer will see these clarification questions.</span>
                            </div>
                            }

                        </div>
                    </fieldset>
                    }

                    <mat-divider></mat-divider>

                    <div class="btn-toolbar d-flex justify-content-center pt-4 pb-4" role="toolbar">
                        @if (isCreating){
                        <mat-spinner [diameter]="30"
                            style="display:inline-block; margin-left: 10px; top: 10px;"></mat-spinner>
                        }@else {
                        @if (clientApp !== undefined && resourceApp !== undefined){
                        <div class="btn-group mr-2 d-flex flex-column align-items-center" role="group">
                            <button class="button" type="submit" [disabled]="!canSubmit" (click)="onSubmit()">submit</button>
                            @if (requiresLpEvaluation && !hasAttemptedEvaluation) {
                            <span class="lp-evaluate-hint mt-1">evaluate your justification with AI before submitting</span>
                            }
                        </div>
                        }
                        <div class="btn-group mr-2" role="group">
                            <button class="button" type="button" (click)="resetForm()">reset</button>
                        </div>
                        }
                    </div>

                    <display-http-error [message]="submitErrorMessage.message"
                        [errors]="submitErrorMessage.errors"></display-http-error>
                    }
                </form>
            </div>
            }@else {
            <div class="col col-12">
                <a class="close-button" [routerLink]="['/applications/request-permissions']"><span
                        class="icon-remove close-button"></span></a>
                <h1>request submitted</h1>
                <display-requests [requests]="createdResponse.requests"></display-requests>
            </div>
            }
        </div>
    </section>
</main>